import styled from 'styled-components'

const GenericTextSpan = styled.span`
  display: ${(props) => (props.display ? props.display : 'inline')};
  width: ${(props) => (props.width ? props.width : 'unset')};
  color: ${(props) => (props.color ? props.color : 'white')};
  font-family: 'Nunito';
  text-align: ${(props) => (props.tAlign ? props.tAlign : 'center')};
  flex-direction: ${(props) => (props.flexDir ? props.flexDir : 'row')};
  font-weight: ${(props) => (props.fWeight ? props.fWeight : 'normal')};
  font-size: ${(props) => (props.fSize ? props.fSize : '1rem')};
  letter-spacing: ${(props) =>
    props.letterSizing ? props.letterSizing : '-0.54px'};
  margin: ${(props) => (props.margin ? props.margin : 'unset')};
  opacity: ${(props) => (props.opacity ? props.opacity : '1')};
  position: ${(props) => (props.position ? props.position : 'relative')};
  top: ${(props) => (props.top ? props.top : 'unset')};
  left: ${(props) => (props.left ? props.left : 'unset')};
  right: ${(props) => (props.right ? props.right : 'unset')};
  bottom: ${(props) => (props.bottom ? props.bottom : 'unset')};
  line-height: ${(props) => (props.lineHeight ? props.lineHeight : 'unset')};
  opacity: ${(props) => (props.opacity ? props.opacity : 'unset')};
  z-index: ${(props) => (props.zIndex ? props.zIndex : 'unset')};
  word-break: ${(props) => (props.wordBreak ? props.wordBreak : 'unset')};

  &.crossed {
    text-decoration: line-through;
  }
  &.pointer {
    cursor: pointer;
  }
  b {
    font-weight: bolder;
  }

  ol {
    list-style-type: disc;
    margin-left: 5%;
  }

  &.accent-color {
    color: #a1ff68;
    font-weight: bold;
    margin-left: 5px;
  }

  &.pln-crossed {
    &:after {
      content: 'zł';
      font-size: 0.6em;
      position: absolute;
      top: 0;
      right: -1em;
    }

    &:before {
      content: '';
      position: absolute;
      left: -5%;
      top: 50%;
      width: 120%;
      height: 2px;
      background-color: #a1ff68;
      transform: rotate(10deg);
    }
  }

  &.pln {
    &:after {
      content: 'zł';
      font-size: 0.6em;
      position: absolute;
      top: 0;
      right: -0.7em;
    }
  }

  big {
    color: #e39401;
  }

  &.strikethrough {
    &:after {
      content: '';
      position: absolute;
      width: 115%;
      height: 2px;
      top: 50%;
      left: -5%;
      background-color: rgb(161, 251, 104);
      transform: rotate(10deg);
    }
  }

  &.player-video-name {
    @media screen and (orientation: landscape) {
      display: none;
    }
  }

  &.light {
    color: #342152;
  }

  span {
    &.email {
      text-decoration: underline;
      font-weight: bold;
      color: #a1ff68;
    }

    &.accent-color {
      color: #a1ff68;
      font-weight: bold;
      margin-left: 5px;
    }

    &.report-bug-data-span {
      margin-left: 5px;
      font-weight: bold;
    }
  }

  .link {
    cursor: pointer;
    color: white !important;
  }

  a {
    color: #a1ff68;
    font-weight: bold;
  }

  &.color-green {
    color: #a1ff68;
  }

  &.button-style {
    cursor: pointer;
  }

  &.login-screen {
    z-index: 2;

    @media only screen and (max-width: 1400px) {
      font-size: 1.5rem;
    }

    @media only screen and (max-width: 1200px) {
      font-size: 1.5rem;
    }
  }

  &.link {
    color: #a1ff68;
    font-weight: bold;
    cursor: pointer;
  }
`

export default GenericTextSpan
